import { render, staticRenderFns } from "./ProbableDuplicateCard.vue?vue&type=template&id=3f66cc09"
import script from "./ProbableDuplicateCard.vue?vue&type=script&lang=ts"
export * from "./ProbableDuplicateCard.vue?vue&type=script&lang=ts"
import style0 from "./ProbableDuplicateCard.vue?vue&type=style&index=0&id=3f66cc09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports